"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Banner_1 = __importDefault(require("../Banner/Banner"));
const NewRelic_1 = __importDefault(require("../NewRelic/NewRelic"));
const CitrusAnalytics_1 = __importDefault(require("../CitrusAnalytics/CitrusAnalytics"));
const bannerUtils_1 = require("../../utils/bannerUtils");
const CitrusBanner = (props) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Banner_1.default, Object.assign({}, props)),
        react_1.default.createElement(CitrusAnalytics_1.default, { adId: props.associatedAdvertId, campaignName: props.bannerCampaignName, type: (0, bannerUtils_1.getBannerAnalyticsType)(props.esiType) }),
        react_1.default.createElement(NewRelic_1.default, { adId: props.associatedAdvertId, esiType: props.esiType })));
};
exports.default = CitrusBanner;
